import { render } from "./layout-header.vue?vue&type=template&id=748477f2&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"

import "./layout-header.vue?vue&type=style&index=0&id=748477f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748477f2"]])

export default __exports__